import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { PATHS } from 'router/config';

export const useGoToMain = () => {
  const navigate = useNavigate();

  const goToMain = useCallback(() => {
    navigate(PATHS.main, { replace: true });
  }, [navigate]);

  return goToMain;
};
